import { API, handleApiError } from "./utils";

// Right after login the Header, Sidebar, Layout and site selectors all call
// getSites() at once, alongside the token-refresh / initial-auth requests.
// Each caller keeps its own copy of the list and never re-fetches on failure,
// so one transient failure left that component's list empty until a full page
// reload. Retrying here fixes every caller at once. (401 is not retried: the
// response interceptor already redirects to sign-in.)
const SITES_RETRY_DELAYS_MS = [400, 1200, 2500];
const isTransientSitesError = (error) => {
    const status = error?.response?.status;
    return !status || status >= 500 || [408, 425, 429].includes(status);
};

export const getSites = async (search, sortOrder, sortedColumn, page, per_page, order_by, companies) => {
    for (let attempt = 0; ; attempt++) {
        try {
            const { data } = await API.get("/get_sites", {
                params: {
                    search,
                    companies,
                    sortOrder,
                    sortedColumn,
                    page,
                    per_page,
                    order_by
                },
            });
            return { error: null, data };
        } catch (error) {
            if (attempt >= SITES_RETRY_DELAYS_MS.length || !isTransientSitesError(error)) {
                return handleApiError(error);
            }
            await new Promise((resolve) => setTimeout(resolve, SITES_RETRY_DELAYS_MS[attempt]));
        }
    }
};
export const siteGet = async (id) => {
    try {
        const { data } = await API.get(`/sites/${id}`);
        // console.log("siteGet",await API.get(`/sites/${id}`))
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const siteAdd = async (site) => {
    try {
        const { data } = await API.post("/sites/", null, {
            params: {
                name: site.Name,
                location: site.location,
                Work_hours:site.Work_hours,
                nbr_workers:site.nbr_workers,
                description: site.Description,
                Lat: site.lat || null,
                Lng: site.lng || null,

            },

        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const siteDrawingUpload = async (siteId, file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const { data } = await API.post(`/sites/${siteId}/drawing`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const siteLayoutGet = async (siteId) => {
    try {
        const { data } = await API.get(`/sites/${siteId}/layout`);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const siteLayoutHeatmapGet = async (siteId, period = "30d") => {
    try {
        const { data } = await API.get(`/sites/${siteId}/layout/heatmap`, {
            params: { period },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const siteUpdate = async (site) => {
    try {
        const { data } = await API.put(`/sites/${site.Site_ID}`, null, {
            params: {
                name: site.Name,
                location: site.location,
                Work_hours:site.Work_hours,
                nbr_workers:site.nbr_workers,
                description: site.Description,
                Lat: site.Lat || null,
                Lng: site.Lng || null,
            },

        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const siteDelete = async (id, options = {}) => {
    try {
        const { data } = await API.delete(`/sites/${id}`, {
            skipSuccessToast: options.skipSuccessToast || false,
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};